import React from 'react';
import { connect } from 'react-redux';
import './index.css';
import { endAnimation } from '../../actions';
import FormIdea from '../../components/formIdea';
import Cycle from '../../components/cycle';

class Home extends React.Component {
    state = {
        startTranslating: false,
        defaultAnimation: false
    }
    componentDidMount() {
        setTimeout(() => {
            this.setState({ startTranslating: true });
        }, 2000);
        setTimeout(() => {
            this.props.endAnimation();
        }, 5500)
    }

    componentWillUnmount() {
        this.props.endAnimation();
    }

    render() {
        let { animationIsEnded } = this.props;
        let { startTranslating } = this.state;
        return (
            <div className="main page">
                {animationIsEnded ?
                    null : <div className={["main__animation", startTranslating ? "main__animation-fadeout2" : ""].join(" ")}></div>}
                <div className="main__img">
                    <div className={["main__content", animationIsEnded ? "" : "main__animation-fadeout3 zeroOpacity"].join(" ")}>
                        <h1 className="main__content__subtitle">{ localStorage.getItem('lang') == 'ru'? 'Разработка':''}</h1>
                        <h1 className="main__title">
                        { localStorage.getItem('lang') == 'ru'? 'интернет-проектов':'PROJECT DEVELOPMENT'}</h1>
                        <h1 className="main__content__title">{ localStorage.getItem('lang') == 'ru'? 'любой сложности':'of any complexity'}</h1>
                    </div>

                    <div className={["main__footer", animationIsEnded ? "" : "main__footer-animation"].join(" ")}>
                        <div className="main__footer__inscription">Creative project is leo</div>
                        <div className="main__footer__line"></div>
                        <div className="main__footer__links">
                            <a href="https://www.behance.net/leotrado8901" className="main__footer__links__social" target="_blank" rel="noopener noreferrer">behance</a>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.pinterest.ru/leotrado/" className="main__footer__links__social">pinterest</a>
                            <a href="https://www.facebook.com/login/?next=https%3A%2F%2Fwww.facebook.com%2Fgroups%2F249633105595577%2F" className="main__footer__links__social" target="_blank" rel="noopener noreferrer">facebook</a>

                        </div>
                    </div>
                </div>
                <div className="main__grey">
                    <h2 className="main__grey__text">
                    { localStorage.getItem('lang') == 'ru'? 'Полный цикл разработки интернет-проектов':'Fullstack development'}</h2>
                    <h6>{ localStorage.getItem('lang') == 'ru'? 'Мы поэтапно прорабатываем все детали проекта, тестируя и дополняя его новыми возможностями.':
                    '7 simple steps for project to be successful'}</h6>
                    <Cycle />
                </div>
                <FormIdea />
            </div>
        )
    }
}


const mapStateToProps = ({ animationIsEnded }) => {
    return {
        animationIsEnded
    }
}

const mapsDispatchToProps = (dispatch) => {
    return {
        endAnimation: () => dispatch(endAnimation()),
    }
}

export default connect(mapStateToProps, mapsDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/pages/home/index.jsx